<template>
  <div class="qualificationApplication">
    <div v-if="!isShow" class="quaul">
      <div class="apply">
        <el-button type="danger" @click="apply">资质申请</el-button>
      </div>
      <ul>
        <li>
          <span class="qast-sp1">机构名称</span>
          <span class="qast-sp2">{{ personalInfo.mechanism_fullName }}</span>
        </li>
        <li>
          <span class="qast-sp1">初审状态</span>
          <span
            class="qast-sp2"
            :style="
              formInfo.approval_status == 2 || formInfo.approval_status == 3
                ? 'color:#67C23A'
                : formInfo.approval_status == 4
                ? 'color:#F56C6C'
                : 'color:#909399'
            "
            >{{
              formInfo.approval_status == 2 || formInfo.approval_status == 3
                ? "已通过"
                : formInfo.approval_status == 4
                ? "未通过"
                : "未审核"
            }}</span
          >
        </li>
        <li>
          <span class="qast-sp1">终审状态</span>
          <span
            class="qast-sp2"
            :style="
              formInfo.approval_status == 3
                ? 'color:#67C23A'
                : formInfo.approval_status == 4
                ? 'color:#F56C6C'
                : 'color:#909399'
            "
            >{{
              formInfo.approval_status == 3
                ? "已通过"
                : formInfo.approval_status == 4
                ? "未通过"
                : "未审核"
            }}</span
          >
        </li>
        <li>
          <span class="qast-sp1">有效时间</span>
          <span
            class="qast-sp2"
            v-if="formInfo.effective_start_date && formInfo.effective_end_date"
            >{{
              formInfo.effective_start_date | dateformat("YYYY-MM-DD HH:mm")
            }}
            至
            {{
              formInfo.effective_end_date | dateformat("YYYY-MM-DD HH:mm")
            }}</span
          >
          <span v-else class="qast-sp2">暂无时间</span>
        </li>
      </ul>
      <table class="table">
        <thead>
          <tr>
            <td>
              <span class="thead_title">审批记录</span>
            </td>
          </tr>
        </thead>
        <tbody
          :style="
            formList.length < 5
              ? 'overflow-y: hidden;'
              : 'overflow-y: scroll;height:150px;'
          "
        >
          <tr v-for="(item, index) in formList" :key="index">
            <td>
              <font class="dot"></font>
              <span v-if="formInfo.approval_time">{{
                item.approval_time | dateformat("YYYY-MM-DD HH:mm")
              }}</span>
              <span v-else>暂无时间</span>
            </td>
            <td style="width: 150px">
              <span
                style="
                  display: block;
                  text-align: justify;
                  text-justify: newspaper;
                  word-break: break-all;
                "
                v-if="item.approval_content"
                >{{ item.approval_content }}</span
              >
              <span v-else>无审批意见</span>
            </td>
            <td>
              <span
                :style="
                  item.approval_status == 2
                    ? 'color:#E6A23C'
                    : item.approval_status == 3
                    ? 'color:#67C23A'
                    : item.approval_status == 4
                    ? 'color:#F56C6C'
                    : 'color:#909399'
                "
                >{{
                  item.approval_status == 2
                    ? "【初审通过,等待终审】"
                    : item.approval_status == 3
                    ? "【终审通过】"
                    : item.approval_status == 4
                    ? "【未通过】"
                    : "【未审核】"
                }}</span
              >
            </td>
            <!-- <td>
              <span>{{item.approval_status==2 || item.approval_status==3?'通过':'未通过'}}</span>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <personalHead
        title="资质申请"
        :hide="true"
        :back="disabled"
        @goBack="goBack"
      />
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构名称" prop="mechanism_fullName">
                <span>{{ personalInfo.mechanism_fullName }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="营业执照" :error="error" :required="true">
                <el-upload
                  class="avatar-uploader center"
                  action="#"
                  accept=".png, .jpeg, .jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFile"
                  :disabled="disabled"
                >
                  <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    class="avatar"
                    @mouseover="imgMouseover"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div
                    class="el-upload-show"
                    :style="active"
                    @mouseleave="imgMouseleave"
                  >
                    <span class="el-upload-span1">
                      <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview()"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        @click.stop="handleRemove()"
                        v-if="!disabled && imageUrl"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="考点地址" required>
                <el-row
                  :gutter="10"
                  style="width: 100%; margin-left: 0px"
                  v-if="!disabled"
                >
                  <el-col :xs="8" :sm="8" :md="8" style="padding-left: 0px">
                    <el-form-item prop="province" class="content">
                      <el-select
                        v-model="ruleForm.province"
                        placeholder="请选择省"
                        style="width: 100%"
                        @change="chooseProvince($event)"
                      >
                        <el-option
                          v-for="item in province"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="8" :sm="8" :md="8">
                    <el-form-item prop="city" class="content">
                      <el-select
                        v-model="ruleForm.city"
                        placeholder="请选择市"
                        style="width: 100%"
                        @change="chooseCity($event)"
                      >
                        <el-option
                          v-for="item in city"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="8" :sm="8" :md="8" style="padding-right: 0px">
                    <el-form-item prop="district" class="content">
                      <el-select
                        v-model="ruleForm.district"
                        placeholder="请选择地区"
                        style="width: 100%"
                        @change="chooseDistrict($event)"
                      >
                        <el-option
                          v-for="item in district"
                          :key="item.id"
                          :label="item.area_name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <span v-else style="padding: 0 15px"
                  >{{
                    ruleForm.province_name == ruleForm.city_name
                      ? ruleForm.province_name
                      : ruleForm.province_name + ruleForm.city_name
                  }}{{ ruleForm.district_name
                  }}{{ ruleForm.testInstitutionalSite }}</span
                >
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" v-if="!disabled">
              <el-form-item label prop="detailed_address">
                <el-input
                  v-model="ruleForm.detailed_address"
                  placeholder="请输入考点详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="申办级别" prop="bidlevel">
                <el-checkbox-group v-model="ruleForm.bidlevel" v-if="!disabled">
                  <el-checkbox
                    v-for="(item, index) in levelList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span v-for="(item, index) in ruleForm.bidlevel" :key="index"
                    >{{ item | grade }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构资质" prop="insQua">
                <el-checkbox-group v-model="ruleForm.insQua" v-if="!disabled">
                  <el-checkbox
                    v-for="(item, index) in insQuaList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span v-for="(item, index) in ruleForm.insQua" :key="index"
                    >{{ item }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="信用" prop="credit">
                <el-checkbox-group v-model="ruleForm.credit" v-if="!disabled">
                  <el-checkbox
                    v-for="(item, index) in creditList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span v-for="(item, index) in ruleForm.credit" :key="index"
                    >{{ item }}。</span
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="宣传推广" prop="pubPromotion">
                <el-checkbox-group
                  v-model="ruleForm.pubPromotion"
                  v-if="!disabled"
                >
                  <el-checkbox
                    v-for="(item, index) in pubPromotionList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span
                    v-for="(item, index) in ruleForm.pubPromotion"
                    :key="index"
                    >{{ item }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="场馆场地设施器材" prop="equipment">
                <el-checkbox-group
                  v-model="ruleForm.equipment"
                  v-if="!disabled"
                >
                  <el-checkbox
                    v-for="(item, index) in equipmentList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span v-for="(item, index) in ruleForm.equipment" :key="index"
                    >{{ item }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="人员管理" prop="PerManage">
                <div v-if="!disabled">
                  <el-checkbox-group v-model="ruleForm.PerManage">
                    <el-checkbox
                      v-for="(item, index) in PerManageList"
                      :label="item.value"
                      :key="index"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                  <el-form-item label="" prop="evaluator_number">
                    <span style="color: #606266; margin-right: 5px">
                      现有中国羽协羽毛球运动水平等级考评员人数
                    </span>
                    <el-input
                      style="width: 200px"
                      v-model="ruleForm.evaluator_number"
                      placeholder="请输入现有考评员数量"
                    />
                  </el-form-item>
                </div>
                <div v-else style="margin: 0 15px">
                  <span v-for="(item, index) in ruleForm.PerManage" :key="index"
                    >{{ item }}、</span
                  >
                  <span>
                    现有中国羽协羽毛球运动水平等级考评员人数：{{
                      ruleForm.evaluator_number
                    }}
                  </span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="塑胶场地数量" prop="plastic_paces_number">
                <el-input
                  v-model="ruleForm.plastic_paces_number"
                  placeholder="请输入塑胶场地数量"
                  v-if="!disabled"
                ></el-input>
                <div v-else style="margin: 0 15px">
                  <span>{{ ruleForm.plastic_paces_number }}</span>
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="组织要求" prop="orgRequirements">
                <el-checkbox-group
                  v-model="ruleForm.orgRequirements"
                  v-if="!disabled"
                >
                  <el-checkbox
                    v-for="(item, index) in orgRequirementsList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span
                    v-for="(item, index) in ruleForm.orgRequirements"
                    :key="index"
                    >{{ item }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="申报绿色通道的机构请填(请注意根据征集通知向中国羽协提交补充材料)"
                prop="greenChannel"
              >
                <el-checkbox-group
                  v-model="ruleForm.greenChannel"
                  v-if="!disabled"
                >
                  <el-checkbox
                    v-for="(item, index) in greenChannelList"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <div v-else style="margin: 0 15px">
                  <span
                    v-for="(item, index) in ruleForm.greenChannel"
                    :key="index"
                    >{{ item }}、</span
                  >
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="机构及场馆设施简介"
                prop="facility_introduct"
              >
                <el-input
                  type="textarea"
                  v-model="ruleForm.facility_introduct"
                  maxlength="500"
                  :readOnly="disabled"
                  @change="(value) => wordNumber(value, '机构及场馆设施简介')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="宣传推广和教育资源"
                prop="promotion_and_education_resources"
              >
                <el-input
                  type="textarea"
                  v-model="ruleForm.promotion_and_education_resources"
                  maxlength="500"
                  :readOnly="disabled"
                  @change="(value) => wordNumber(value, '宣传推广和教育资源')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="近两年承办培训班或其他重大活动的主要情况"
                prop="recent_situation"
              >
                <el-input
                  type="textarea"
                  v-model="ruleForm.recent_situation"
                  maxlength="500"
                  @change="
                    (value) =>
                      wordNumber(
                        value,
                        '近两年承办培训班或其他重大活动的主要情况'
                      )
                  "
                  :readOnly="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" v-if="!disabled">
              <el-form-item prop="xuzhi">
                <div class="xuzhi">
                  须知：中国羽协及省级羽协每年对测试机构进行考核，考核标准可咨询各省份省级羽协，考核不合格机构原则上取消合作，请合理安排测试活动。
                </div>
                <el-checkbox v-model="ruleForm.xuzhi">
                  上述机构考核介绍我已知悉
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" v-if="!disabled">
              <el-form-item class="agree" prop="agree">
                <el-checkbox-group v-model="ruleForm.agree">
                  <el-checkbox>
                    本机构自愿申请成为中国羽毛球协会运动水平等级评定测试机构，承诺并保
                    <br />证以上所提交的材料真实有效，并愿意承担相应的法律责任。
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item class="submit">
                <el-button
                  @click="goBack('ruleForm')"
                  plain
                  type="danger"
                  v-if="disabled"
                  >返 回</el-button
                >
                <!-- 审批未通过 -->
                <el-button
                  @click="edit()"
                  type="danger"
                  v-if="
                    (personalInfo.approval_status == 1 ||
                      personalInfo.approval_status == 4) &&
                    disabled
                  "
                  >编 辑</el-button
                >
                <el-button
                  @click="edit1()"
                  type="danger"
                  plain
                  v-if="
                    !disabled &&
                    (!formInfo ||
                      personalInfo.approval_status == 1 ||
                      personalInfo.approval_status == 4)
                  "
                  >取消编辑</el-button
                >
                <el-button
                  type="danger"
                  @click="save('ruleForm')"
                  :disabled="ruleForm.agree.length == 0 || !ruleForm.xuzhi"
                  :loading="loading"
                  v-if="!disabled"
                  >提 交</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import personalHead from "@/views/admin/components/personalHead.vue";
import {
  CreateQualifications,
  GetTestQualificationsDetails,
} from "@/api/admin/test.js";
import { GetDicData, GetDistrictList } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
let that;
export default {
  components: {
    personalHead,
  },
  computed: {
    ...mapGetters(["personalInfo"]),
  },
  data() {
    return {
      ruleForm: {
        bidlevel: [],
        insQua: [],
        credit: [],
        equipment: [],
        PerManage: [],
        pubPromotion: [],
        orgRequirements: [],
        greenChannel: [],
        agree: [],
        xuzhi: false,
        province: "",
        city: "",
        district: "",
        evaluator_number: ''
      },
      formInfo: {},
      form: {},
      formList: [],
      isShow: true,
      rules: {
        business_license_key: [
          { required: true, message: "请上传营业执照", trigger: "blur" },
        ],
        detailed_address: [
          {
            required: true,
            message: "请填写考点详细地址",
            trigger: "blur",
          },
        ],
        plastic_paces_number: [
          {
            required: true,
            message: "请输入塑胶场地数量",
            trigger: "blur",
          },
          {
            pattern: /^\d+$/,
            message: "请输入正确的数量",
            trigger: "blur",
          },
        ],
        evaluator_number: [
          {
            pattern: /^\d+$/,
            message: "请输入正确的数量",
            trigger: "blur",
          },
        ],
        orgRequirements: [
          {
            required: true,
            message: "请选择组织要求",
            trigger: "change",
            type: "array",
          },
        ],
        bidlevel: [
          {
            required: true,
            message: "请选择申办级别",
            trigger: "change",
            type: "array",
          },
        ],
        insQua: [
          {
            required: true,
            message: "请选择机构资质",
            trigger: "change",
            type: "array",
          },
        ],
        credit: [
          {
            required: true,
            message: "请选择信用",
            trigger: "change",
            type: "array",
          },
        ],
        equipment: [
          {
            required: true,
            message: "请选择场馆场地设施器材",
            trigger: "change",
            type: "array",
          },
        ],
        PerManage: [
          {
            required: true,
            message: "请选择人员管理",
            trigger: "change",
            type: "array",
          },
        ],
        pubPromotion: [
          {
            required: true,
            message: "请选择宣传推广",
            trigger: "change",
            type: "array",
          },
        ],
        facility_introduct: [
          {
            required: true,
            message: "请填写机构及场馆设施简介",
            trigger: "blur",
          },
        ],
        promotion_and_education_resources: [
          {
            required: true,
            message: "请填写宣传推广和教育资源",
            trigger: "blur",
          },
        ],
        recent_situation: [
          {
            required: true,
            message: "请填写近两年承办培训班或其他重大活动的主要情况",
            trigger: "blur",
          },
        ],
        agree: [
          {
            required: true,
            message: "请确认资料真实性",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: "change",
          },
        ],
        district: [
          {
            required: true,
            message: "请选择市",
            trigger: "change",
          },
        ],
      },
      // 申办级别
      levelList: [],

      // 机构资质
      insQuaList: [
        {
          label: "在国家各级工商或民政部门有效注册",
          value: "在国家各级工商或民政部门有效注册",
        },
        {
          label: "具备独立法人资格",
          value: "具备独立法人资格",
        },
        {
          label: "有体育活动组织的经营许可",
          value: "有体育活动组织的经营许可",
        },
      ],

      // 信用
      creditList: [
        {
          label: "无重大投诉纠纷",
          value: "无重大投诉纠纷",
        },
        {
          label: "无培训教学事故或考试意外事故",
          value: "无培训教学事故或考试意外事故",
        },
        {
          label: "无虚假宣传、欺诈、违约等不良记录",
          value: "无虚假宣传、欺诈、违约等不良记录",
        },
        {
          label: "三年内无违反《中国羽毛球协会章程》或其他规定的行为",
          value: "三年内无违反《中国羽毛球协会章程》或其他规定的行为",
        },
        {
          label:
            "服从中国羽协和省级羽协在运动水平等级评定方面的管理，并按照协议约定开展等级评定工作",
          value:
            "服从中国羽协和省级羽协在运动水平等级评定方面的管理，并按照协议约定开展等级评定工作",
        },
      ],

      // 场馆场地设施器材
      equipmentList: [
        {
          label: "有符合国家安全标准的室内场馆",
          value: "有符合国家安全标准的室内场馆",
        },
        {
          label: "至少有4片标准羽毛球塑胶场地",
          value: "至少有4片标准羽毛球塑胶场地",
        },
        {
          label: "提供充足的评定所需用球和其他设施器材",
          value: "提供充足的评定所需用球和其他设施器材",
        },
      ],

      // 人员管理
      PerManageList: [
        {
          label: "有专职负责等级评定的工作人员",
          value: "有专职负责等级评定的工作人员",
        },
        {
          label: "能根据相关规定选用考评员",
          value: "能根据相关规定选用考评员",
        },
        {
          label: "有保证测试正常进行的安全和医护人员",
          value: "有保证测试正常进行的安全和医护人员",
        },
        {
          label: "有中国羽协羽毛球运动水平等级考评员的机构优先",
          value: "有中国羽协羽毛球运动水平等级考评员的机构优先",
        },
      ],
      // 绿色通道
      greenChannelList: [
        {
          label: "优秀运动员机构",
          value: "优秀运动员机构",
        },
        {
          label: "各级各类学校",
          value: "各级各类学校",
        },
        {
          label: "优秀社会机构",
          value: "优秀社会机构",
        },
        {
          label: "中国羽协认定的全国羽毛球后备人才基地",
          value: "中国羽协认定的全国羽毛球后备人才基地",
        },
      ],
      // 组织要求
      orgRequirementsList: [
        {
          label:
            "测试机构每年至少举办1次等级测试，原则上每年测试累计不少于100人次",
          value:
            "测试机构每年至少举办1次等级测试，原则上每年测试累计不少于100人次",
        },
      ],
      // 宣传推广
      pubPromotionList: [
        {
          label:
            "按照中国羽协、省级羽协的推广方案，完成等级评定的宣传和推广工作",
          value:
            "按照中国羽协、省级羽协的推广方案，完成等级评定的宣传和推广工作",
        },
        {
          label: "积极向教育部门推进，促进羽毛球运动水平等级评定工作进校园",
          value: "积极向教育部门推进，促进羽毛球运动水平等级评定工作进校园",
        },
        {
          label: "具有图文直播等拍摄设备及组织能力",
          value: "具有图文直播等拍摄设备及组织能力",
        },
      ],

      isdisabled: false,
      disabled: false,
      loading: false,
      uploadFiles: [],
      localFile: {},
      error: "",
      error1: "",
      dialogVisible: false,
      dialogImageUrl: "",
      active: "",
      imageUrl: "",
      dicData: {
        test_class_can_apply_for_grade: "test_class_can_apply_for_grade",
        event_apply_status: "event_apply_status",
      },
      event_apply_status: [],
      province: [],
      city: [],
      district: [],
      imgPath: window.apiObj.apiUrl,
    };
  },
  created() {
    this.imageUrl = this.personalInfo.business_license_key;
    this.dicDa();
    this.getList();
  },
  watch: {
    // "ruleForm.province"(val) {
    //    GetDistrictList({ parent_id: val }).then(data => {
    //       this.city = data.data.result.items;
    //       this.ruleForm.city = this.city[0].id;
    //       this.chooseCity(this.ruleForm.city);
    //    });
    // },
    "ruleForm.nickName"(val) {
      if (!val) {
        this.error1 = "";
      }
    },
  },
  methods: {
    getList() {
      GetTestQualificationsDetails({}).then((data) => {
        const list = data.data.result;
        if (list) {
          if (list.items.length > 0) {
            this.isdisabled = true;
            this.disabled = true;
            this.isShow = false;
            this.formInfo = list.items[0];
            this.formList = list.items;

            this.ruleForm.province = list.items[0].province;
            this.ruleForm.city = list.items[0].city;
            this.ruleForm.district = list.items[0].district;
            GetDistrictList({ parent_id: "-1" }).then((data) => {
              if (data.data.result) {
                this.province = data.data.result.items;
              }
            });
            GetDistrictList({ parent_id: this.ruleForm.province }).then(
              (data) => {
                if (data.data.result) {
                  this.city = data.data.result.items;
                }
              }
            );
            GetDistrictList({ parent_id: this.ruleForm.city }).then((data) => {
              if (data.data.result) {
                this.district = data.data.result.items;
              }
            });
            this.ruleForm.province_name = list.items[0].province_name;
            this.ruleForm.city_name = list.items[0].city_name;
            this.ruleForm.district_name = list.items[0].district_name;
            this.ruleForm.testInstitutionalSite =
              list.items[0].testInstitutionalSite;
            this.ruleForm.institutional_site_id =
              list.items[0].institutional_site_id;
            this.form.id = list.items[0].id;
            this.ruleForm.mechanism_fullName = list.items[0].mechanism_fullName;
            this.imageUrl = this.imgPath + list.items[0].attachments;
            this.$set(
              this.ruleForm,
              "plastic_paces_number",
              list.items[0].plastic_paces_number
            );
            this.$set(
              this.ruleForm,
              "evaluator_number",
              list.items[0].evaluator_number
            );
            this.$set(
              this.ruleForm,
              "detailed_address",
              list.items[0].testInstitutionalSite
            );
            this.$set(
              this.ruleForm,
              "promotion_and_education_resources",
              list.items[0].promotion_and_education_resources
            );
            this.$set(
              this.ruleForm,
              "recent_situation",
              list.items[0].recent_situation
            );
            this.$set(
              this.ruleForm,
              "facility_introduct",
              list.items[0].facility_introduct
            );
            this.ruleForm.bidlevel = list.items[0].grade.split(",");
            var a = this.formInfo.comprehensive_content.split("+");
            var b = [];
            a.forEach((j) => {
              b.push(j.split("_"));
            });
            window.console.log(b);
            this.ruleForm.insQua = b[0];
            this.ruleForm.credit = b[1];
            this.ruleForm.pubPromotion = b[2];
            this.ruleForm.equipment = b[3];
            this.ruleForm.PerManage = b[4];
            this.ruleForm.orgRequirements = b[5] ? b[5] : [];
            this.ruleForm.greenChannel = b[6] ? b[6] : [];
          } else {
            this.isdisabled = false;
            this.disabled = false;
            this.isShow = true;
          }
        }
      });
    },
    dicDa() {
      GetDicData({
        classCode: this.dicData.test_class_can_apply_for_grade,
      }).then((data) => {
        if (data.data.result.length > 0) {
          this.levelList = data.data.result;
        }
      });
      GetDicData({
        classCode: this.dicData.event_apply_status,
      }).then((data) => {
        if (data.data.result.length > 0) {
          this.event_apply_status = data.data.result;
        }
      });
      GetDistrictList({ parent_id: "-1" }).then((data) => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
    },
    apply() {
      this.isShow = true;
    },
    goBack() {
      this.isShow = false;
    },
    save(ruleForm) {
      this.form.isFormSubmit = true;
      this.form.business_license_key = this.localFile;
      this.form.nickName = this.ruleForm.nickName;
      this.form.province = this.ruleForm.province;
      this.form.city = this.ruleForm.city;
      this.form.district = this.ruleForm.district;
      this.form.detailed_address = this.ruleForm.detailed_address;
      // this.form.testInstitutionalSite = this.ruleForm.detailed_address;
      this.form.institutional_site_id = this.ruleForm.institutional_site_id;
      this.form.facility_introduct = this.ruleForm.facility_introduct;
      this.form.user_test_mechanism_id = this.personalInfo.id;
      this.form.nickName = "小李";
      this.translation();

      if (!this.imageUrl) {
        this.error = "请上传营业执照";
      } else {
        this.error = "";
      }

      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.translation();
          this.loading = true;
          CreateQualifications(this.form)
            .then((data) => {
              if (data.data.result.isSuccess) {
                this.$message({
                  message: data.data.result.errorMsg,
                  type: "success",
                });
                this.goBack();
                this.loading = false;
                this.getList();
                this.$router.go(0);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    translation() {
      var grade = this.ruleForm.bidlevel;
      // this.form.comprehensive_content = {
      //    institutionalQualification: this.ruleForm.insQua,
      //    credit: this.ruleForm.credit,
      //    venueFacilitiesAndEquipment: this.ruleForm.equipment,
      //    personalManagement: this.ruleForm.PerManage,
      //    promotion: this.ruleForm.pubPromotion
      // };
      var comprehensive_content = [
        this.ruleForm.insQua.join("_"),
        this.ruleForm.credit.join("_"),
        this.ruleForm.pubPromotion.join("_"),
        this.ruleForm.equipment.join("_"),
        this.ruleForm.PerManage.join("_"),
        this.ruleForm.orgRequirements.join("_"),
        this.ruleForm.greenChannel.join("_"),
      ];
      this.form.comprehensive_content = comprehensive_content.join("+");
      this.form.grade = grade.join(",");
      this.form.promotion_and_education_resources =
        this.ruleForm.promotion_and_education_resources;
      this.form.recent_situation = this.ruleForm.recent_situation;
      this.form.plastic_paces_number = this.ruleForm.plastic_paces_number;
      this.form.evaluator_number = this.ruleForm.evaluator_number;
    },
    edit() {
      this.isdisabled = true;
      this.disabled = false;
    },
    edit1() {
      this.disabled = true;
    },
    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      this.active = "display:none;opacity: 0;";
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
          this.localFile.type === "image/jpeg" ||
          this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传营业执照只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("上传营业执照大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    chooseProvince(item) {
      GetDistrictList({ parent_id: item }).then((data) => {
        this.city = data.data.result.items;
        this.ruleForm.city = this.city[0].id;
        GetDistrictList({ parent_id: this.ruleForm.city }).then((data) => {
          this.district = data.data.result.items;
          this.ruleForm.district = this.district[0].id;
        });
      });
    },
    chooseCity(item) {
      GetDistrictList({ parent_id: item }).then((data) => {
        this.district = data.data.result.items;
        this.ruleForm.district = this.district[0].id;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    },
    wordNumber(val, label) {
      if (val.length == 500) {
        this.$message({
          message: label + "  内容已达到最大限制",
          type: "warning",
          duration: 5000,
        });
      }
    },
  },
  beforeCreate: function () {
    that = this;
  },
  filters: {
    grade: (data) => {
      for (var i in that.levelList) {
        if (that.levelList[i].value == data) {
          return that.levelList[i].label;
        }
      }
    },
    event: (data) => {
      for (var i in that.event_apply_status) {
        if (that.event_apply_status[i].value == data) {
          return that.event_apply_status[i].label;
        }
      }
    },
    pro: (data) => {
      for (var i in that.province) {
        if (that.province[i].id == data) {
          return that.province[i].area_name;
        }
      }
    },
    cit: (data) => {
      for (var i in that.city) {
        if (that.city[i].id == data) {
          return that.city[i].area_name;
        }
      }
    },
    dis: (data) => {
      for (var i in that.district) {
        if (that.district[i].id == data) {
          return that.district[i].area_name;
        }
      }
    },
  },
};
</script>
<style lang="less">
.qualificationApplication {
  .form {
    width: 90%;
    .el-form-item__label {
      padding-right: 42px;
      font-size: 14px;
      font-weight: 400;
    }
    .el-textarea__inner {
      min-height: 150px !important;
      font-family: "微软雅黑";
    }
    .agree .el-checkbox__input {
      position: relative;
      top: -20px;
    }
    .border {
      .el-input__inner {
        border-width: 0px !important;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-upload-show {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      display: none;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      line-height: 9;
      .el-upload-span1 {
        span {
          padding: 0px 20px;
        }
      }
    }
  }
  .quaul {
    width: 65%;
    padding: 5% 10px 10% 10px;
    .apply {
      padding: 10px 30px 10px 0px;
      text-align: right;
    }
    ul {
      li {
        height: 40px;
        line-height: 40px;
        .qast-sp1 {
          display: inline-block;
          width: 40%;
          text-align: right;
          color: #888;
        }
        @media screen and (max-width: 500px) {
          .qast-sp1 {
            width: 30% !important;
          }
        }
        .qast-sp2 {
          margin-left: 50px;
          color: #444;
        }
      }
    }
    .table {
      width: 100%;
      margin: 0 auto;
      margin-top: 50px;
      font-size: 0.9rem;
      .dot {
        width: 5px;
        height: 5px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
        top: -3px;
        background-color: #f15660;
        margin-right: 5px;
      }
      .thead_title {
        display: inline-block;
        padding-left: 22px;
        margin-bottom: 10px;
      }
      ::-webkit-scrollbar {
        width: 7px;
      }

      /*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/

      ::-webkit-scrollbar-track {
        width: 6px;
        background-color: #c0c4cc;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }

      /*滚动条的设置*/

      ::-webkit-scrollbar-thumb {
        background-color: #8dc3ff;
        background-clip: padding-box;
        min-height: 28px;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
      tbody {
        text-align: center;
        display: block;
        overflow-x: hidden;
        tr {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
        }
      }
    }
    @media screen and (max-width: 768px) {
      .table {
        width: 100% !important;
      }
    }
  }
  .el-page-header {
    padding: 5px 20px;
  }
  @media screen and (max-width: 1024px) {
    .quaul {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 500px) {
    .form {
      width: 100% !important;
      .el-form-item__label {
        width: 110px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        float: none;
      }
      .center {
        text-align: center;
      }
      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }

  .xuzhi {
    line-height: 20px;
    font-weight: 800;
  }
}
</style>
